import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const StockKpiStrip = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(11rem, 1fr));
  gap: 0.75rem;
  margin-bottom: 1rem;
`

export const StockCellText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
`

export const StockNameLine = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
`

export const StockCellName = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StockCellMeta = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
  font-variant-numeric: tabular-nums;
`

export const StockOnHandValue = styled.span<{ $belowMin: boolean }>`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${(props) => (props.$belowMin ? tokens.status.danger.fg : tokens.text.primary)};
  font-variant-numeric: tabular-nums;
`

export const StockNumText = styled.span`
  font-size: ${tokens.font.body};
  color: ${tokens.text.primary};
  font-variant-numeric: tabular-nums;
`

export const StockReservedValue = styled.span<{ $active: boolean }>`
  font-size: ${tokens.font.body};
  color: ${(props) => (props.$active ? tokens.text.primary : tokens.text.muted)};
  font-variant-numeric: tabular-nums;
`

export const StockAvailableValue = styled.span<{ $committed: boolean }>`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${(props) => (props.$committed ? tokens.status.danger.fg : tokens.text.primary)};
  font-variant-numeric: tabular-nums;
`

export const StockCommitNote = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.status.danger.fg};
`
